import { Trans, useTranslation } from "react-i18next";
import yoloIt from "../assets/img/yolo_it.svg";
import yoloEn from "../assets/img/yolo_en.svg";
import EventList from "../business/EventList";
import italianFlag from "../assets/img/italian.svg";
import englishFlag from "../assets/img/english.svg";

const Body = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = () => {
    const newLanguage = i18n.language === "it-it" ? "en-gb" : "it-it";
    i18n.changeLanguage(newLanguage);
  };

  const flagImg = i18n.language === "it-it" ? englishFlag : italianFlag;
  const yoloImg = i18n.language === "it-it" ? yoloIt : yoloEn;

  return (
    <main className="landing">
      <div className="intro position-relative overflow-hidden px-3 py-2 text-center">
        <div className="col-10 text-end">
          <a href="#lang" onClick={() => changeLanguage()}>
            <img src={flagImg} alt="language" className="language" />
          </a>
        </div>
        <div className="col-md-8 py-lg-3 mx-auto">
          <img alt="logo" src={yoloImg} className="logo" />
          <h1 className="mb-3">{t("main title")}</h1>
          <p className="fw-normal lead">
            <strong>{t("subtitle")}</strong>
          </p>
          <p className="fw-normal">
            <Trans t={t} i18nKey="description1">
              <strong>0</strong> 1 <strong>2</strong> 3 <strong>4</strong>5
            </Trans>
            <br />
            <Trans t={t} i18nKey="description2">
              0<strong>1</strong>2<strong>3</strong>4
            </Trans>
            <br />
            <Trans t={t} i18nKey="description3">
              <a href={t("informative set link")}>0</a> 1
            </Trans>
          </p>
        </div>
      </div>

      <div className="events position-relative overflow-hidden px-3 py-5 text-center">
        <div className="col-md-9 mx-auto">
          <p className="fw-normal lead">
            <Trans t={t} i18nKey="event list description">
              0<strong>1</strong>2
            </Trans>
          </p>
          <EventList />
        </div>
      </div>
    </main>
  );
};

export default Body;
